import { gql } from '@grandvisionhq/graphql';
import { orderResultsFragment } from '../fragments/line-item.js';

const GET_MY_ORDER_HISTORY = gql`
  query getMyOrderHistory($offset: Int!, $limit: Int!) {
    me {
      id
      orders(offset: $offset, limit: $limit) {
        total
        failures {
          reason
        }
        results {
          ...OrderResultsFragment
        }
      }
    }
  }
  ${orderResultsFragment}
`;

export { GET_MY_ORDER_HISTORY };
//# sourceMappingURL=get-my-order-history.js.map
